import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgCommentPlusIcon = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "Comment with a plus in the center",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="29"
    height="30"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <g clipPath="url(#clip0_7706_16403)">
      <path
        d="M5.25377 26.3958C5.12372 26.5052 4.96515 26.5752 4.79669 26.5976C4.62823 26.62 4.45688 26.5939 4.30276 26.5223C4.14864 26.4507 4.01816 26.3365 3.92665 26.1933C3.83513 26.0502 3.78639 25.8838 3.78613 25.7139V7.85672C3.78613 7.61992 3.8802 7.39282 4.04764 7.22538C4.21509 7.05794 4.44219 6.96387 4.67899 6.96387H24.3218C24.5586 6.96387 24.7857 7.05794 24.9532 7.22538C25.1206 7.39282 25.2147 7.61992 25.2147 7.85672V22.1424C25.2147 22.3792 25.1206 22.6063 24.9532 22.7738C24.7857 22.9412 24.5586 23.0353 24.3218 23.0353H9.14328L5.25377 26.3958Z"
        stroke={color}
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_7706_16403)">
        <path
          d="M10.8174 16.0271L13.1611 18.3708L18.5183 13.0137"
          stroke={color}
          strokeWidth="1.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7706_16403">
        <rect
          width="28.5714"
          height="28.5714"
          fill="white"
          transform="translate(0.213867 0.713867)"
        />
      </clipPath>
      <clipPath id="clip1_7706_16403">
        <rect
          width="10.7143"
          height="10.7143"
          fill="white"
          transform="translate(9.14258 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

const CommentPlusIcon = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgCommentPlusIcon />
  </BaseIcon>
);

export default CommentPlusIcon;
